import React from "react";
import AppRoutes from "../routes";
import HomePage from "../pages/chi/home_page";
const ChiTemplate = () => {
  return (
    <div>
      <React.Fragment>
        <AppRoutes homePage={HomePage} />
      </React.Fragment>
    </div>
  );
};

export default ChiTemplate;
